export default __webpack_public_path__ + "static/media/img-13.a8835d0d.jpg";